module.exports = __webpack_public_path__ + "573a3b714bdf7f3f8e7a356ca2cd1991.svg";